import { render, staticRenderFns } from "./courer.vue?vue&type=template&id=b127c056&scoped=true"
import script from "./courer.vue?vue&type=script&lang=js"
export * from "./courer.vue?vue&type=script&lang=js"
import style0 from "./courer.vue?vue&type=style&index=0&id=b127c056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b127c056",
  null
  
)

export default component.exports